/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';

import './assets/css/documents.css';
import './assets/lib/angular-ui-tree/dist/angular-ui-tree.css';

require('./assets/lib/angular-ui-tree/dist/angular-ui-tree.js');
require('./assets/lib/ng-file-upload/ng-file-upload.js');

import 'angularjs-dropdown-multiselect';



// WEBPACK FOOTER //
// ./packages/custom/documents/public/index.js